import { FormType } from '@/__generated__/types';
import { FORM_TYPE_OPTIONS } from '@/constants/form';
import i18n from '@/utils/lenguage/config';
import { SchemaOf, mixed, object, string } from 'yup';
import { POS_INQUIRY_HEARD_FROM_OPTIONS } from '@/constants/posInquiry';
import { PosInquiryFormValues } from './types';
import { matchIsValidTel, type MuiTelInputCountry } from 'mui-tel-input';

const validationMessage = (key: string) => (): string => i18n.t(key);

export const posInquiryValidationSchema: SchemaOf<PosInquiryFormValues> = object({
    formType: mixed<FormType>()
        .oneOf([...FORM_TYPE_OPTIONS], validationMessage('posInquiry.validation.formTypeRequired'))
        .required(validationMessage('posInquiry.validation.formTypeRequired')),
    restaurantName: string().trim().required(validationMessage('posInquiry.validation.restaurantNameRequired')),
    contactName: string().trim().required(validationMessage('posInquiry.validation.contactPersonNameRequired')),
    mobileCountry: mixed<MuiTelInputCountry>().required(validationMessage('posInquiry.validation.mobileCountryRequired')),
    mobileNumber: string()
        .trim()
        .required(validationMessage('posInquiry.validation.mobileNumberRequired'))
        .test('valid-mobile-number-for-country', validationMessage('posInquiry.validation.mobileNumberInvalid'), function (value) {
            if (!value) return true;

            const mobileCountry = this.parent.mobileCountry as MuiTelInputCountry | undefined;
            if (!mobileCountry) return false;

            return matchIsValidTel(value, { onlyCountries: [mobileCountry] });
        }),
    email: string()
        .trim()
        .required(validationMessage('posInquiry.validation.emailAddressRequired'))
        .email(validationMessage('posInquiry.validation.emailAddressInvalid')),
    city: string().trim().required(validationMessage('posInquiry.validation.cityRequired')),
    businessType: string().trim().required(validationMessage('posInquiry.validation.businessTypeRequired')),
    message: string().ensure().trim(),
    referralSource: mixed<PosInquiryFormValues['referralSource']>()
        .oneOf([...POS_INQUIRY_HEARD_FROM_OPTIONS], validationMessage('posInquiry.validation.heardFromRequired'))
        .required(validationMessage('posInquiry.validation.heardFromRequired'))
});
